import React, { useEffect, useState } from 'react';
import { i18n } from 'core/i18n';
import HireNewCreditLimit from 'components/hire/hireCreditLimit/hireNewCreditLimit';
import HireNewPaymentMethod from 'components/hire/hirePaymentMethod/hireNewPaymentMethod';
import { OKMessage } from 'commonsComponents/OKMessage';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { WIZARD_THIRD_STEP } from 'constants/index';
import bannerImage from 'assets/images/cards/creditCardBanner.png';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
const { FormattedText } = i18n;
import { NOT_MAX_LIMIT, CARD_PAYMENT_METHOD_UNIQUE } from 'constants/index';

export const HireNewCreditCardStep1 = ({
    immGlobalVariables,
    hireCreditCard,
    immHireCreditLimit,
    immHirePaymentMethod,
    toggleCreditLimitModal,
    validate,
    getHiring,
    defaultLimit,
    setTooltipShown,
    handleTypeChange,
    handleValueChange,
    requestAfiInformation,
    setAFIParams,
    setInneParams,
    newSetHireCreditCardType,
    immFlagBasedFeatures,
    immPdfRevolvingPersistent,
    revolvingPackId,
    handleCreditLimitModalValueChange,
    handleToggleModal,
    handleCreditLimitChange,
    creditType,
    onCheckboxChange,
    agreeCheckboxCC,
    isCheckboxCheckedStep1,
    setIsCheckboxCheckedStep1
}) => {
    const paymentMethodType = immHirePaymentMethod.get('type');
    const sliderMarks = immHireCreditLimit.get('marks');

    const creditLimit = __CONTACT_CENTER__ && !isPrintOfficeMode() && immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT
        ? sliderMarks.get(0)
        : (immHireCreditLimit.get('creditLimit') === NOT_MAX_LIMIT ? sliderMarks.get(0) : immHireCreditLimit.get('creditLimit'));
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsCheckboxCheckedStep1(checked);
        onCheckboxChange(checked);
    };
    useEffect(() => {
        if (!immHireCreditLimit.get('fetchSuccess')) {
            getHiring(hireCreditCard.get('type'), hireCreditCard.get('subtype'), hireCreditCard.get('standard'), defaultLimit);
        }
    }, []);

    useEffect(() => {
        if (!(__CONTACT_CENTER__ && !isPrintOfficeMode() && maximumLimitAuthorize && maximumLimitAuthorize !== NOT_MAX_LIMIT) && paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE) {
            setIsCheckboxCheckedStep1(true);
            onCheckboxChange(true);
        }
    }, [maximumLimitAuthorize, paymentMethodType]);

    const onCreditLimitModalContinue = () => {
        newSetHireCreditCardType(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_THIRD_STEP, true);
    };
    const getTinValue = (creditType) => {
        const tinValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tin']),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tin']),
            'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_tin']),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_tin']),
        };

        return tinValues[creditType];
    };
    const getTaeValue = (creditType, tae) => {
        const taeValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', tae]),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', tae]),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', tae]),
            'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, tae]),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', tae]),
        };

        return taeValues[creditType];
    };

    const confirmationAgentLabel = <FormattedText value="cc_hireNewCreditCard-confirmationAgentLabel" />
    const maxPreaprovedValue = immHireCreditLimit.get('maxValue');
    const maximumLimitAuthorize = immHireCreditLimit.get('maximumLimitAuthorize');

    const renderBlockInfo = () => (
        <BlockInfo>
            <p className="requiredReading">
                <FormattedText value="cc_hireNewCreditCard-requiredReading" />
            </p>
            <FormattedText value="cc_hireNewCreditCard-step1InfoMonthlyPayment" />
        </BlockInfo>
    );

    const renderOKMessage = () => (
        <OKMessage type="informative">
            <FormattedText value={paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE ? 'hireNewCreditCard-step1Info' : 'hireNewCreditCard-step1InfoPA'} />
        </OKMessage>
    );

    const renderContinueContracting = () => (
        <BlockInfo>
            <FormattedText value="cc_hireNewCreditCard-step1ContinueContracting" />
        </BlockInfo>
    );
    const setHireCreditLimit = (creditLimit, resetModalValue) => (
        handleCreditLimitChange(creditLimit, resetModalValue)

    );
    return (
        <article className="hire-card-neruda-step-three hire-new-credit-cards-cc">
            {!immHireCreditLimit.get('fetchSuccess') ? <LoadingSection /> :
                <>
                    <FormattedText
                        className="hire-card-neruda__step-title"
                        value='hireNewCreditCard-title'
                    />
                    <h4 className="hire-card-neruda__section-header">
                        <FormattedText value='hireNewCreditCard-subTitle' />
                    </h4>
                    {__CONTACT_CENTER__ && !isPrintOfficeMode() && maximumLimitAuthorize && maximumLimitAuthorize !== NOT_MAX_LIMIT ? (
                        <>
                            <BlockInfo>
                                <p className="requiredReading">
                                    <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                                </p>
                                <FormattedText
                                    value="cc_hireNewCreditCard-agentInformation_limitCredit_text_one"
                                />
                                <span> {maxPreaprovedValue}</span>
                                <FormattedText
                                    value="cc_hireNewCreditCard-agentInformation_limitCredit_text_two"
                                />
                            </BlockInfo>
                            <OKCheckbox
                                idName="hireNewCreditCardAgentConfirmationStepOne"
                                label={confirmationAgentLabel}
                                onChange={handleCheckboxChange}
                                value={isCheckboxCheckedStep1}
                            />
                        </>
                    ) : null}
                    <HireNewCreditLimit
                        handleModalContinue={onCreditLimitModalContinue}
                        immHireCreditLimit={immHireCreditLimit}
                        immHirePaymentMethod={immHirePaymentMethod}
                        productSubType={hireCreditCard.get('subtype')}
                        productType={hireCreditCard.get('type')}
                        referenceStandard={hireCreditCard.get('standard')}
                        newSetCardLimit={true}
                        bannerImage={bannerImage}
                        immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                        handleCreditLimitChange={setHireCreditLimit}
                        handleCreditLimitModalValueChange={handleCreditLimitModalValueChange}
                        handleToggleModal={handleToggleModal}
                        isCheckboxChecked={isCheckboxCheckedStep1}
                        creditLimit={creditLimit}
                    />
                    <HireNewPaymentMethod
                        immHireCreditLimit={immHireCreditLimit}
                        immGlobalVariables={immGlobalVariables}
                        immHirePaymentMethod={immHirePaymentMethod}
                        isNerudaCard={true}
                        newSetCardLimit={true}
                        setTooltipShown={setTooltipShown}
                        handleTypeChange={handleTypeChange}
                        handleValueChange={handleValueChange}
                        requestAfiInformation={requestAfiInformation}
                        setAFIParams={setAFIParams}
                        setInneParams={setInneParams}
                        newSetHireCreditCardType={newSetHireCreditCardType}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        immPdfRevolvingPersistent={immPdfRevolvingPersistent}
                        getTinValue={getTinValue}
                        getTaeValue={getTaeValue}
                        creditType={creditType}
                        isCheckboxChecked={isCheckboxCheckedStep1}
                        agreeCheckboxCC={agreeCheckboxCC}
                        setIsCheckboxCheckedStep1={setIsCheckboxCheckedStep1}
                    />
                    {__CONTACT_CENTER__ && !isPrintOfficeMode()
                        ? (paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE && renderBlockInfo())
                        : renderOKMessage()
                    }
                    {__CONTACT_CENTER__ && !isPrintOfficeMode() && renderContinueContracting()}
                </>
            }
        </article>
    );
};

